export default __webpack_public_path__ + "static/media/jonny-gios-gBr5Hmx1STc-unsplash.76d43df0.jpg";